/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Promised Prepayment Actions
 *
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */

import { IErrorResponse } from '../../sagas/requestSaga';
import { createAction } from '../app/createAction';
import {
    PROMISED_PAYMENT_GET_AMOUNT_ACTION,
    PROMISED_PAYMENT_GET_AMOUNT_FAILURE,
    PROMISED_PAYMENT_GET_AMOUNT_SUCCESS,
    PROMISED_PAYMENT_SUBMIT_ACTION,
    PROMISED_PAYMENT_SUBMIT_FAILURE,
    PROMISED_PAYMENT_SUBMIT_SUCCESS,
} from './promisedPaymentConstants';
import {
    IPromisedPaymentGetAmountActionPayload,
    IPromisedPaymentGetAmountSuccessPayload,
    TPromisedPaymentGetAmountAction,
    TPromisedPaymentGetAmountFailure,
    TPromisedPaymentGetAmountSuccess,
    TPromisedPaymentSubmitAction,
    TPromisedPaymentSubmitFailure,
    TPromisedPaymentSubmitSuccess,
} from './promisedPaymentTypes';

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const promisedPaymentGetAmountAction =
    (payload: IPromisedPaymentGetAmountActionPayload): TPromisedPaymentGetAmountAction =>
        createAction(PROMISED_PAYMENT_GET_AMOUNT_ACTION, payload);
export const promisedPaymentGetAmountSuccess =
    (payload: IPromisedPaymentGetAmountSuccessPayload): TPromisedPaymentGetAmountSuccess =>
        createAction(PROMISED_PAYMENT_GET_AMOUNT_SUCCESS, payload);
export const promisedPaymentGetAmountFailure =
    (payload: IErrorResponse): TPromisedPaymentGetAmountFailure =>
        createAction(PROMISED_PAYMENT_GET_AMOUNT_FAILURE, payload);

export const promisedPaymentSubmitAction =
    (payload: IPromisedPaymentGetAmountActionPayload): TPromisedPaymentSubmitAction =>
        createAction(PROMISED_PAYMENT_SUBMIT_ACTION, payload);
export const promisedPaymentSubmitSuccess =
    (payload: IPromisedPaymentGetAmountSuccessPayload): TPromisedPaymentSubmitSuccess =>
        createAction(PROMISED_PAYMENT_SUBMIT_SUCCESS, payload);
export const promisedPaymentSubmitFailure =
    (payload: IErrorResponse): TPromisedPaymentSubmitFailure =>
        createAction(PROMISED_PAYMENT_SUBMIT_FAILURE, payload);
